import React, { PropsWithChildren } from 'react';

import styles from './dictionary-components.module.scss';

export default function AkBlack({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkBlack}>{children}</span>;
}
